<template>
    <div class="main model-box ptn course-list">
        <div v-if="list && list!=''" class="model-box__bd clear">
            <coach-course-card v-for="(item,index) in list" :key="index" :course="item" :roles="roles"></coach-course-card>
        </div>
        <div v-else class="tac norecord">
            <i class="iconfont">&#xe646;</i><br/>
            暂无记录
        </div>

        <div class="clear bcw buybar">
          <div class="buybar__content clear">
            <router-link v-if="roles=='ROLE_CLUB_ADMIN'" :to="{name: 'courseitemadd'}">
                <van-button type="primary" size="large" class="fs3">新建课程</van-button>
            </router-link>
            <router-link v-if="roles=='ROLE_COACH'" :to="{name: 'coachcourseadd'}">
                <van-button type="primary" size="large" class="fs3">新建课程</van-button>
            </router-link>
          </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import { Toast } from 'vant';
import CoachCourseCard from '@/components/CoachCourseCard';
Vue.use(Toast);
export default {
    name: 'CourseListManage',
    components: {
        CoachCourseCard
    },
    data(){
      return {
        list:{},  // 团课列表
        total:0 ,  // 总数
        roles:this.$route.params.roles,  //角色
        clubId:this.$route.params.clubId
      }
    },
    created(){
        let _this = this;
        if(this.roles == 'ROLE_CLUB_ADMIN'){
            //俱乐部管理员 团课列表
            this.$http.post('club_group_course_manage/getList').then(function(res){                
                if(!res.data.code){
                    _this.list = res.data.value.data
                    _this.total = res.data.value.total
                }else{
                    Toast.fail(res.data.message)
                }          
            })
        }else if(this.roles == 'ROLE_COACH'){
            //教练 私教课列表
            this.$http.get('club_pt_course_manage/getList?coachId=' + this.$route.params.coachId).then(function(res){                
                if(!res.data.code){
                    _this.list = res.data.value.data
                    _this.total = res.data.value.total
                }else{
                    Toast.fail(res.data.message)
                }          
            })
        }
    }
}
</script>

<style lang="less" scoped>
@supports (bottom: constant(safe-area-inset-bottom)) or (bottom: env(safe-area-inset-bottom)) {
  .buybar {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/CourseListManage.vue